/** TanStack Query keys for the buyer SPA. One place, so WS invalidation and mutations agree. */
export const qk = {
  me: ['me'] as const,
  config: ['config'] as const,
  categories: ['catalog', 'categories'] as const,
  products: (filters: { categoryId?: string; q?: string }) =>
    ['catalog', 'products', filters] as const,
  product: (id: string) => ['catalog', 'product', id] as const,
  cart: ['cart'] as const,
  orders: (page: number) => ['orders', page] as const,
  order: (number: string) => ['orders', 'detail', number] as const,
  notifications: ['notifications'] as const,
  telegramStatus: ['telegram', 'status'] as const,
  buyerProfile: ['buyer', 'profile'] as const,
  chat: ['chat'] as const,
  chatMessages: ['chat', 'messages'] as const,
} as const;
